import { UserPopover } from "@/components/popovers/user-popover";
import { cva, type VariantProps } from "@msuite/ui/libs/cva";
import { Popover } from "@msuite/ui/popover";
import { Tooltip } from "@msuite/ui/tooltip";
import { cn } from "@msuite/ui/utils";
import type { ProjectCard } from "@msuite/utils/types";
import { getFullName } from "@msuite/utils/users";
import { UserAvatar } from "../user-card/user-avatar";

/** Props Interface */
interface ProjectMembersProps extends VariantProps<typeof stack> {
	members: ProjectCard["_members"];
}

export function ProjectMembers({ members, justify }: ProjectMembersProps) {
	const managers = members?.filter((member) => member.role === "manager");
	const deputies = members?.filter((member) => member.role === "deputy-manager");

	/** Classes */
	const classes = stack({ justify });

	if (!managers?.length && !deputies?.length) return null;

	/** Render */
	return (
		<div className={cn("gap-0 hover:[&>.user-avatar]:ml-1 h-stack transition-all", classes)}>
			{managers?.map((user) => (
				<div
					key={user.userId}
					className="z-10 relative"
				>
					<Popover
						trigger="click"
						render={() => <UserPopover userId={user.userId} />}
					>
						<Tooltip label={getFullName(user._user)}>
							<UserAvatar
								userId={user.userId}
								className="ring ring-white dark:ring-primary-950"
								variant="initials"
							/>
						</Tooltip>
					</Popover>
				</div>
			))}
			{deputies?.map((user, index) => (
				<div
					key={user.userId}
					className={cn("relative transition-all user-avatar", managers?.length && "-ml-2")}
					style={{
						zIndex: 9 - index,
					}}
				>
					<Popover
						trigger="click"
						render={() => <UserPopover userId={user.userId} />}
					>
						<Tooltip label={`${getFullName(user._user)} (${user.role})`}>
							<UserAvatar
								userId={user.userId}
								variant="initials"
								className="ring ring-white dark:ring-primary-950"
							/>
						</Tooltip>
					</Popover>
				</div>
			))}
		</div>
	);
}

const stack = cva([], {
	variants: {
		justify: {
			start: "justify-start",
			end: "justify-end",
		},
	},
	defaultVariants: {
		justify: "end",
	},
});
